<template>
	<router-view></router-view>
</template>

<script type="text/javascript">

	export default {
		name: 'BilanSaison',
	}

</script>